export default function PageHero({ eyebrow, title, children, image, imageAlt }) {
  return (
    <section className="relative bg-charcoal text-white">
      {image && (
        <>
          <img
            src={image}
            alt={imageAlt || ""}
            className="absolute inset-0 w-full h-full object-cover"
            loading="eager"
          />
          <div className="absolute inset-0 bg-charcoal/60" aria-hidden="true" />
        </>
      )}
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        {eyebrow && (
          <p className="text-xs tracking-[0.25em] uppercase font-semibold text-gold mb-4">{eyebrow}</p>
        )}
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight leading-tight max-w-3xl">
          {title}
        </h1>
        {children && (
          <div className="mt-6 max-w-2xl text-base sm:text-lg text-white/85 leading-relaxed">{children}</div>
        )}
      </div>
    </section>
  );
}
